import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 's-section-title',
  templateUrl: './section-title.component.html',
  styleUrls: ['./section-title.component.scss'],
})
export class SSectionTitleComponent implements OnInit {
  constructor() {}

  @Input() title?: string | undefined;
  @Input() caption?: string | undefined;

  ngOnInit(): void {}
}
